import { render, staticRenderFns } from "./workspace.html?vue&type=template&id=f61bc8d0&scoped=true&"
import script from "./workspace.js?vue&type=script&lang=js&"
export * from "./workspace.js?vue&type=script&lang=js&"
import style0 from "./workspace.scss?vue&type=style&index=0&id=f61bc8d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61bc8d0",
  null
  
)

export default component.exports